export default {
  ADD_USER: '@USER/ADD_USER',
  ADD_USER_SUCCESS: '@USER/ADD_USER_SUCCESS',
  ADD_USER_FAILURE: '@USER/ADD_USER_FAILURE',
  SET_REMEMBER_ME: '@USER/SET_REMEMBER_ME'
}
